<template>
    <PageTitle :page-title="'Личный кабинет'">
        <template v-if="currentTab !== 'main'" #back-action-link>
            <button class="back-link" @click="changeTab('main')">Вернуться назад</button>
        </template>
        <template v-else #btns>
            <div class="page-header__btns">
                <button class="btn btn--border btn--fav" @click="changeTab('favorite')">Избранное<span>({{getFavoriteTendersCount || 0}})</span></button>
                <a href="http://lk.nahodka.market/index.php?r=site%2Flogin" target="_blank" class="btn btn--color btn--sticky">Создать карточку товара</a>
            </div>
        </template>
    </PageTitle>
    <div class="page-content">
        <div class="wrapper">
            <div class="page-content__wrapper">

                <div class="page-content__aside">
                    <PageNav></PageNav>
                </div>

                <div class="page-content__content">
                    <PageLoader v-if="isLoading"/>

                    <template v-if="currentTab === 'main'">
                        <SupplyTendersPage @changeTab="changeTab('favorite')"/>
                    </template>

                    <template v-else-if="currentTab === 'favorite'">
                        <SupplyFavPage @changeTab="changeTab('main')"/>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SupplyTendersPage from "@/components/sections/LcSupply/SupplyTenders/SupplyTendersPage.vue";
import SupplyFavPage from "@/components/sections/LcSupply/SupplyFav/SupplyFavPage.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import PageNav from "@/components/blocks/PageNav.vue";
import PageTitle from "@/components/blocks/PageTitle.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "LcSupplyPage",
    components: {PageLoader, SupplyFavPage, SupplyTendersPage, PageNav, PageTitle},
    data() {
        return {
            currentTab: 'main'
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'isLoading',
            getFavoriteTendersCount: 'tenders/getFavoriteTendersCount'
        })
    },
    methods: {
        changeTab(newTab) {
            this.currentTab = newTab
            this.updatePagination({offset: 0})
        },
        ...mapActions({
            updatePagination: 'tenders/updatePagination',
        })
    }
}
</script>

